module.exports = __webpack_public_path__ + "static/media/cultec_logov2-2.458cb96f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/cultec_logov2-2.png
// module id = 3029
// module chunks = 0